var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.998 402.645L296.852 618.79l56.458 56.46 119.766-119.767V952.14h79.844V555.484L672.686 675.25l56.458-56.46zm319.256-16.288C827.532 212.14 684.342 71.86 509.006 71.86c-80.548 0-157.724 29.8-217.314 83.907-51.346 46.62-86.042 107.914-99.628 175.06-48.54 10.438-92.846 35.546-127.126 72.5C23.062 448.48 0 507.277 0 568.89c0 134.28 109.244 243.523 243.524 243.523.318 0 .632-.004.862-.008h41.056V732.56l-42.146.01c-90.148-.125-163.452-73.503-163.452-163.68 0-84.73 66.062-156.393 150.398-163.143l33.136-2.652 3.394-33.066c12.77-124.467 116.91-218.327 242.234-218.327 134.28 0 243.524 109.244 243.524 243.524v69.864h57.886c73.744 0 133.738 59.995 133.738 133.74S884.16 732.566 810.416 732.566l-69.864-.014V812.4h68.564c.434.01.866.015 1.3.015C928.188 812.415 1024 716.6 1024 598.83c0-110.4-84.19-201.505-191.746-212.473z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.65d55c446ca2691b7172ae15f45106b4.svg";
export { ForwardRef as ReactComponent };